const routes = {
  logout: 'logout',
  crmUploadReport: 'crm-upload-report',
  costReport: 'agency-cost-report',
  userManagement: {
    userManagement: 'business-agency-user-management',
    userInvite: 'business-agency-user-management-user-invite',
  },
  prospectionMap: 'prospection-map',
  agencyProfile: 'agency-profile',
  contactList: 'contact-list',
  referenceListings: 'reference-listings',
  visibilityPlus: 'visibility-plus',
  ecosystem: 'ecosystem',
  insights: 'business-listing-insights',
  listingLeads: 'listing-leads',
  sellerLeads: 'seller-leads',
  sellerLeadsActiveDistricts: 'seller-leads-active-districts',
  userProfile: 'user-profile',
  packageOverview: 'agency-package-overview',
  invoices: 'invoices',
  deeplink: 'deeplink',
  unsubscribe: 'unsubscribe-nba',
  whatsNew: 'whats-new',
  winningMandate: 'winning-mandate',
  toplistings: {
    boostForPropertyReferenceId: 'boost-for-property-reference-id',
  },
};

export default routes;
